import React, { useState, useEffect } from 'react';
import { ProjectsContext } from '../context/contexts';
import { api } from '../api/instance';
import { useAuth } from '../hooks/useAuth';

export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [projectsCopy, setProjectsCopy] = useState([]);
  const [projectsError, setProjectsError] = useState('');
  const [projectCount, setProjectCount] = useState();
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [updateProjects, setUpdateProjects] = useState(true);
  const { isAuthenticated } = useAuth();


  useEffect(() => {
    const getProjects = async () => {
      try {
        if (updateProjects && isAuthenticated) {
          setLoadingProjects(true);
          // Need to add pagination to the projects page
          const response = await api.get('/projects?page=0&limit=100');
          setProjects(response.data.projects);
          setProjectsCopy(response.data.projects);
          setProjectCount(response.data.count);
          setLoadingProjects(false);
          setUpdateProjects(false);
        }
      } catch (e) {
        console.log('errors', e);
        setProjectsError('Failed to load projects. Please try again later. If the issue persists, contact support.');
      }
    };

    getProjects();
  }, [updateProjects, isAuthenticated]);

  return (
    <ProjectsContext.Provider
      value={{
        projects,
        setProjects,
        projectCount,
        loadingProjects,
        setUpdateProjects,
        projectsError,
        projectsCopy
      }}>
      {children}
    </ProjectsContext.Provider>
  );
};
